import React from 'react'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import HomeIcon from '@mui/icons-material/Home';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import Face5OutlinedIcon from '@mui/icons-material/Face5Outlined';
import Face4OutlinedIcon from '@mui/icons-material/Face4Outlined';
import ThreePIcon from '@mui/icons-material/ThreeP';
import { Button } from '@mui/material';
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import Tooltip from '@mui/material/Tooltip';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import ArticleIcon from '@mui/icons-material/Article';
import AreYouSureModal from '../../../components/AreYouSureModal';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

export default function InfoTab({ student, handleFileRemove, setRemoveTargetFile }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const season = {1: 'Spring', 2: 'Summer', 3: 'Fall', 4: 'Winter'};

    // for deleting file
    const [open, setOpen] = React.useState(false);
    const handleOpen = (file) => {   
        setRemoveTargetFile(file);
        setOpen(true);
    };

    const sortSemesterHashMap = new Map();
    if (student.student_courses !== null && student.student_courses !== undefined) {
        student.student_courses.map((student_course) => {
            // 여기서 이미 title이 순서대로 안 나오니까, 여기서 start date로 sorting을 해줘야 함
            const sortSemesters = [...student_course.course.course_semesters].sort((a, b) => {                
                return dayjs(a.semester.start) - dayjs(b.semester.start);
            });
            return sortSemesterHashMap.set(student_course.course.id, sortSemesters);
        });
    }

    // latest courses first: course end_date desc, then start_date desc; courses without dates go last
    const sortedStudentCourses = [...(student.student_courses || [])].sort((a, b) => {
        const aEnd = a.course?.end_date ? dayjs(a.course.end_date).valueOf() : -Infinity;
        const bEnd = b.course?.end_date ? dayjs(b.course.end_date).valueOf() : -Infinity;
        if (aEnd !== bEnd) return bEnd - aEnd;
        const aStart = a.course?.start_date ? dayjs(a.course.start_date).valueOf() : -Infinity;
        const bStart = b.course?.start_date ? dayjs(b.course.start_date).valueOf() : -Infinity;
        return bStart - aStart;
    });

    const courseDuration = (course) => {
        const sortSemesters = sortSemesterHashMap.get(course.id) || [];
        const start_year = sortSemesters[0]?.semester?.year || "";
        const start_season = season[sortSemesters[0]?.semester?.season] || "";
        const end_year = sortSemesters[sortSemesters?.length - 1]?.semester?.year || "";
        const end_season = season[sortSemesters[sortSemesters?.length - 1]?.semester?.season] || "";

        if (sortSemesters.length === 1)
            return `${start_year} ${start_season}`;
        else
            return `${start_year} ${start_season} - ${end_year} ${end_season}`;
    };

    const renderStudentInfoLink = () => {
        if (!student.student_info_link) return "N/A";

        const { 
            current_year, 
            current_year_season, 
            break_date_answer_1,
            next_year,
            next_year_season,
            break_date_answer_2,
        } = student.student_info_link;

        const currentSeason = current_year && current_year_season ? `${current_year} ${current_year_season}` : "N/A";
        const nextSeason = next_year && next_year_season ? `${next_year} ${next_year_season}` : "N/A";

        return (
            <Typography component='span' mt={1} mb={1} ml={1} variant='h5'>
                {currentSeason} {break_date_answer_1 ? `: ${break_date_answer_1}` : "N/A"} <br />
                {nextSeason} {break_date_answer_2 ? `: ${break_date_answer_2}` : "N/A"}
            </Typography>
        );
    }

    return (
        <>
        <Grid container direction="row" alignItems="center" ml={1} mb={0.5}>
            <Grid item>
                <BubbleChartIcon />
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h3'> Student</Typography>
            </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item>
                <Tooltip title="Email" placement="top" arrow>
                    <AlternateEmailIcon />
                </Tooltip>
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h5'> {student.email ? student.email : "N/A"}</Typography>
            </Grid>
        </Grid>
        {student.ett_email && (
            <Grid container direction="row" alignItems="center" ml={3}>
                <Grid item>
                    <Tooltip title="ETT Email" placement="top" arrow>
                        <AlternateEmailIcon />
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Typography component='span' mb={1} ml={1} variant='h5'> ETT: {student.ett_email}</Typography>
                </Grid>
            </Grid>
        )}
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item>
                <Tooltip title="Phone" placement="top" arrow>
                    <PhoneIphoneIcon />
                </Tooltip>
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h5'>{student.phone ? student.phone : "N/A"}</Typography>
            </Grid>
        </Grid>
        {student.address === null || student.address === undefined ? null : (
            <Grid container direction="row" alignItems="center" ml={3}>
                <Grid item>
                    <Tooltip title="Address" placement="top" arrow>
                        <HomeIcon />
                    </Tooltip>
                </Grid>
                <Grid item>
                    <Typography component='span' mb={1} ml={1} variant='h5'>
                        {student.address.street}, {student.address.city}, {student.address.state} {student.address.zip}, {student.address.country}
                    </Typography>
                </Grid>
            </Grid>
        )}
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item>
                <Tooltip title="Remark (특이사항)" placement="top" arrow>
                    <ThreePIcon />
                </Tooltip>
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h5'>
                    {student.remark ? student.remark : "N/A"}
                </Typography>
            </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item mb={"auto"}>
                <Tooltip title="방학" placement="top" arrow>
                    <HistoryEduIcon />
                </Tooltip>
            </Grid>
            <Grid item>
                    {student.student_info_link 
                        ? renderStudentInfoLink() 
                        : <Typography component='span' mb={1} ml={1} variant='h5'>N/A</Typography>
                    }
            </Grid>
        </Grid>
        <br />
        <Grid container direction="row" alignItems="center" ml={1} mb={0.5}>
            <Grid item>
                <BubbleChartIcon />
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h3'> Student Information Files</Typography>
            </Grid>
        </Grid>
        <Grid container ml={3} wrap="nowrap">
            {/* File List Container */}
            <Grid item xs>
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.5rem",
                        whiteSpace: "nowrap",
                    }}
                >
                    {student.student_info_files && student.student_info_files.length > 0 ? (
                        student.student_info_files.map((file, index) => (
                            <Box 
                                key={index} 
                                sx={{ 
                                    display: "flex", 
                                    alignItems: "center", 
                                    gap: "0.5rem",
                                    backgroundColor: "#f5f5f5",
                                    padding: "0 4px",
                                    borderRadius: "8px",
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <ArticleIcon />
                                </Box>
                                <Box
                                    key={index}
                                    component="a"
                                    href={file.file_url}
                                    target="_blank"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        color: "inherit",
                                    }}
                                >
                                    <Typography variant="body1">{file.name}</Typography>
                                </Box>
                            
                                <IconButton onClick={() => {handleOpen(file.id)}} size="small">
                                    <Tooltip title="Delete this file">
                                        <ClearIcon fontSize='small'/>
                                    </Tooltip>
                                </IconButton>
                            </Box>
                        ))
                    ) : (
                        <Typography component="span" variant="h5" ml={1}>
                            No files yet.
                        </Typography>
                    )}
                </Box>
            </Grid>
        </Grid>
        <br />
        <Grid container direction="row" alignItems="center" ml={1} mb={0.5}>
            <Grid item>
                <BubbleChartIcon />
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h3'> Parent</Typography>
            </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item>
                <Tooltip title="Email" placement="top" arrow>
                    <AlternateEmailIcon />
                </Tooltip>
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h5'>{student.parent_email ? student.parent_email : "N/A"}</Typography>
            </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item>
                <Tooltip title="Phone" placement="top" arrow>
                    <PhoneAndroidIcon />
                </Tooltip>
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h5'>{student.parent_phone ? student.parent_phone : "N/A"}</Typography>
            </Grid>
        </Grid>
        <Grid container direction="row" alignItems="center" ml={3}>
            <Grid item>
                <Tooltip title="Gender" placement="top" arrow>
                    {student.parent_gender === null || student.parent_gender === "" ? <Groups2OutlinedIcon /> 
                        : student.parent_gender === "Male" ? <Face5OutlinedIcon />
                        : <Face4OutlinedIcon />
                    }
                </Tooltip>
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h5'>
                    {student.parent_gender === null || student.parent_gender === "" ? "Gender not specified" : student.parent_gender}
                </Typography>
            </Grid>
        </Grid>
        <br />
        <Grid container direction="row" alignItems="center" ml={1} mb={0.5}>
            <Grid item>
                <BubbleChartIcon />
            </Grid>
            <Grid item>
                <Typography component='span' mb={1} ml={1} variant='h3'> Courses</Typography>
            </Grid>
        </Grid>
        {sortedStudentCourses.length > 0 ? (
            sortedStudentCourses.map((element, index) => {
                if ((element.is_confirmed === false && element.course.is_potential_course === true)
                    || (element.course.is_potential_course === true))
                    return null;

                // if code starts with 'Z', it is for final exam, so we don't show it
                if (element.course.code && element.course.code.startsWith('Z-'))
                    return null;
                
                return (
                    <React.Fragment key={index}>
                        <Grid container direction="row" alignItems="center" ml={3}>
                            <Grid item>
                                <ArrowRightIcon />
                            </Grid>
                            <Grid item>
                                <Typography component='a' mb={1} ml={1} variant='h5' href={`/classrooms/${element.course.uuid}/home`} target="_blank">
                                    ({element.course.code ?? 'n/a'}) {element.course.course_title}, {courseDuration(element.course)}
                                    {/* {element.course.is_potential_course ? "(Confirmed)" : ""} */}
                                </Typography>
                            </Grid>
                        </Grid>
                        {element.student_course_consultations && element.student_course_consultations.map((consultation) => (
                            <Grid key={"consultation-" + consultation.id} container direction="row" alignItems="flex-start" ml={6} wrap="nowrap">
                                <Grid item>
                                    <Tooltip
                                        title={`Consultation${consultation.created_by ? ` by ${consultation.created_by}` : ""}${consultation.createdAt ? ` (${dayjs(consultation.createdAt).format("MM/DD/YYYY")})` : ""}`}
                                        placement="top"
                                        arrow
                                    >
                                        <SupportAgentIcon fontSize="small" sx={{ color: colors.purpleAccent[500] }} />
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    <Typography component='span' ml={1} variant='h6' sx={{ whiteSpace: "pre-wrap" }}>
                                        {consultation.memo}
                                    </Typography>
                                </Grid>
                            </Grid>
                        ))}
                    </React.Fragment>
                );
            })) : (
                <Box sx={{ mb: "1rem" }}>
                    <Typography component='span' ml={1} variant='h5'>No courses yet.</Typography>
                </Box>
            )
        }
        <br />
        {!student.is_potential_student && 
            <Button
                type="submit"
                variant="contained"
                href={`/admin/students/${student.uuid}/class-logs`}
                style={{
                    backgroundColor: colors.primary[300],
                    color: "white",
                    width: "10rem",
                }}
            >
                Student Logs
            </Button>
        }
        <AreYouSureModal
            colors={colors}
            title="Delete a file"
            message="Please confirm to delete this file. This action cannot be undone."
            onConfirm={handleFileRemove}
            setOpen={setOpen}
            open={open}
        />
        </>
    )
}